<div class="top">
    <app-flight-group [group]="form().controls.flight" [lookups]="lookups()" [groundRun]="groundRun()"></app-flight-group>
    <div class="right">
        <app-leg-group [group]="form().controls.flight" [departures]="lookups().departures" [arrivals]="lookups().arrivals" [groundRun]="groundRun()"></app-leg-group>
        <app-times-group [group]="form().controls.flight"></app-times-group>
    </div>
</div>

<app-fuel-group [group]="form().controls.fuel" [units]="lookups().fuelUnits" [maxTank]="lookups().maxTank"></app-fuel-group>
